import { render, staticRenderFns } from "./HomePanelInfo.vue?vue&type=template&id=188b7057&"
import script from "./HomePanelInfo.vue?vue&type=script&lang=js&"
export * from "./HomePanelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports